
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressMortgagesEN]",
      function () {
        return require("private-next-pages/[...wordpressMortgagesEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressMortgagesEN]"])
      });
    }
  